import { render, staticRenderFns } from "./ticket-stock-edit.vue?vue&type=template&id=6c5bbf7a&scoped=true&"
import script from "./ticket-stock-edit.vue?vue&type=script&lang=js&"
export * from "./ticket-stock-edit.vue?vue&type=script&lang=js&"
import style0 from "./ticket-stock-edit.vue?vue&type=style&index=0&id=6c5bbf7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5bbf7a",
  null
  
)

export default component.exports